const config = {
  blockPaymentWhenDesignIsDeprecated: true,
};

module.exports = config;
